import React, { useEffect, useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import RiHero from "../components/ri/RiHero";
import RiJourney from "../components/ri/RiJourney";
import ImpactWall from "../components/ri/ImpactWall";
import ProjectExplorer from "../components/ri/ProjectExplorer";
import QuoteBand from "../components/ri/QuoteBand";
import ActivityFeed from "../components/ri/ActivityFeed";
import RiWheel from "../components/ri/RiWheel";
import RiPeople from "../components/ri/RiPeople";
import RiStats from "../components/ri/RiStats";
import UkMap from "../components/ri/UkMap";
import RiReports from "../components/ri/RiReports";
import RiTargets from "../components/ri/RiTargets";
import RiFinale from "../components/ri/RiFinale";
import StoryModal from "../components/ri/StoryModal";
import { Chapter, ScrollThread } from "../components/ri/Chapter";
import { getStory } from "../data/impactStories";
import { useLocation, useNavigate } from "react-router-dom";

const sections = [
  { id: "journey", label: "Journey" },
  { id: "wall", label: "Impact Wall" },
  { id: "explorer", label: "Explorer" },
  { id: "latest", label: "Latest Activity" },
  { id: "wheel", label: "Navigate" },
  { id: "people", label: "People" },
  { id: "numbers", label: "The Record" },
  { id: "map", label: "UK Map" },
  { id: "reports", label: "Reports" },
  { id: "targets", label: "Targets" }
];

function SectionNav() {
  const [active, setActive] = useState("");
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    let raf = 0;
    const onScroll = () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        setVisible(window.scrollY > window.innerHeight * 0.8);
        let current = "";
        sections.forEach((s) => {
          const el = document.getElementById(s.id);
          if (el && el.getBoundingClientRect().top < 180) current = s.id;
        });
        setActive(current);
      });
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => { window.removeEventListener("scroll", onScroll); cancelAnimationFrame(raf); };
  }, []);

  return (
    <div
      data-testid="ri-section-nav"
      className={`fixed top-[74px] lg:top-[82px] left-0 right-0 z-30 transition-all duration-500 ${
        visible ? "translate-y-0 opacity-100" : "-translate-y-full opacity-0 pointer-events-none"
      }`}
    >
      <div className="bg-black/85 backdrop-blur-xl border-b border-white/10">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 flex items-center gap-1 overflow-x-auto no-scrollbar py-2.5">
          {sections.map((s) => (
            <a
              key={s.id}
              href={`#${s.id}`}
              data-testid={`ri-nav-${s.id}`}
              className={`px-3.5 py-1.5 rounded-full text-xs whitespace-nowrap transition-colors ${
                active === s.id ? "bg-[#F5D000] text-black font-semibold" : "text-white/60 hover:text-white"
              }`}
            >
              {s.label}
            </a>
          ))}
        </div>
      </div>
    </div>
  );
}

export default function ESG() {
  const [story, setStory] = useState(null);
  const { search } = useLocation();
  const navigate = useNavigate();

  // Deep link: /esg?story=<id> opens the story modal directly
  useEffect(() => {
    const id = new URLSearchParams(search).get("story");
    if (id) {
      const s = getStory(id);
      if (s) setStory(s);
      navigate("/esg", { replace: true });
    }
  }, [search, navigate]);

  return (
    <div className="relative" data-testid="ri-page">
      <Header />
      <ScrollThread />
      <SectionNav />
      <RiHero />
      <Chapter number="01" title="The Journey" />
      <RiJourney onOpenStory={setStory} />
      <Chapter number="02" title="The Impact Wall" />
      <ImpactWall onOpenStory={setStory} />
      <Chapter number="03" title="Inside a Live Scheme" />
      <ProjectExplorer onOpenStory={setStory} />
      <QuoteBand />
      <Chapter number="04" title="Latest Activity" />
      <ActivityFeed onOpenStory={setStory} />
      <Chapter number="05" title="Navigate by Impact" />
      <RiWheel onOpenStory={setStory} />
      <Chapter number="06" title="The People" />
      <RiPeople onOpenStory={setStory} />
      <RiStats />
      <Chapter number="07" title="Across the UK" />
      <UkMap onOpenStory={setStory} />
      <Chapter number="08" title="Reports & Policies" />
      <RiReports />
      <Chapter number="09" title="The Targets" />
      <RiTargets />
      <RiFinale />
      <Footer />
      <StoryModal story={story} onClose={() => setStory(null)} onOpenStory={setStory} />
    </div>
  );
}
